import Tag from "@/components/Tag";
import { TagType } from "@/components/Tag/Tag";
import type { MaterialNames } from "@/components/material_symbol_names";
import { FacilityOperatingStatus } from "@/types";

type OperatingStatusConfig = { tagType: TagType; icon?: MaterialNames };

const OPERATING_STATUS_MAP: Record<string, OperatingStatusConfig> = {
  OPEN: { tagType: "success" },
  CLOSED: { tagType: "error", icon: "close" },
  SUSPENDED: { tagType: "warn", icon: "pause" },
  SEASONAL: { tagType: "information", icon: "calendar_today" },
  MAINTENANCE: { tagType: "warn", icon: "build" },
  TEMPORARY_CLOSED: { tagType: "warn", icon: "schedule" },
  ARCHIVED: { tagType: "surface", icon: "archive" }
};

export const renderOperatingStatus = (
  status: FacilityOperatingStatus | null | undefined,
  label: string | undefined,
  tagStyle: "standard" | "strong" = "strong"
) => {
  if (!label) return null;

  const config = status
    ? OPERATING_STATUS_MAP[status] || { tagType: "surface" as TagType }
    : { tagType: "surface" as TagType };

  return (
    <Tag tagType={config.tagType} tagStyle={tagStyle} iconName={config.icon}>
      {label}
    </Tag>
  );
};
